import {TextField} from 'react-admin';

const TextFieldMod = props => {
    return (<TextField {...props} />);
};

export default TextFieldMod;